/**
 * Format an ISO date string or Date object to HH:mm
 * @param {String|Date} value
 * @returns {String|null}
 */
export function formatTimeOnly(value) {
  if (!value) return null;
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleTimeString("zh-TW", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * Format a scheduled time string (HH:mm:ss or HH:mm) to HH:mm
 * @param {String} value
 * @returns {String|null}
 */
export function formatScheduledTime(value) {
  if (!value) return null;
  const parts = String(value).split(":");
  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]}`;
  }
  return value;
}

/**
 * Format value to YYYY/MM/DD HH:mm
 * @param {String|Date} value
 * @returns {String}
 */
export function formatDateTime(value) {
  if (!value) return "-";

  const stringValue = String(value).trim();
  if (!stringValue) return "-";

  // Handle YYYY-MM-DD HH:mm format specifically if needed
  const timePattern = /^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2}))?$/;
  const match = stringValue.match(timePattern);
  if (match) {
    const [, year, month, day, hour, minute] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const time = hour && minute ? ` ${hour}:${minute}` : "";
    return `${date.toLocaleDateString("zh-TW")}${time}`;
  }

  const date = new Date(stringValue);
  if (!isNaN(date.getTime())) {
    return date.toLocaleString("zh-TW", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  return stringValue;
}

/**
 * Convert minutes to days (8 hours/day) formatted to 1 decimal place
 * @param {Number|String} minutes
 * @returns {String}
 */
export function convertMinutesToDays(minutes) {
  const mins = parseFloat(minutes) || 0;
  return (mins / 480).toFixed(1);
}
